import axios from 'axios'
const debug = process.env.NODE_ENV !== 'production'

export default {
    strict: debug,
    namespaced: true,
    state: {
        count: 0,
        // coverindex: 0,
        currentUser: {
            get UserName () {
                return localStorage.getItem('currentUser_name')
            },
            get UserToken () {
                return localStorage.getItem('currentUser_token')
            },
            get RefreshToken () {
                return localStorage.getItem('currentUser_refresh_token')
            },
            get Expires () {
                return localStorage.getItem('expires')
            },
        },
        appInfo: {
            get appList () {
                return localStorage.getItem('appList')
            },
        },
        isLogin: {
            get value () {
                // let isLogin = sessionStorage.getItem('isLogin')
                let isLogin = localStorage.getItem('isLogin')
                return isLogin === 'true'
            }
        },
        accountInfo: {
            get accountInfo () {
                return JSON.parse(localStorage.getItem('accountInfo'))
            },
        },
    },
    getters: {},
    mutations: {
        increment (state) {
            state.count += 1
        },
        setUser (state, { userName, userToken, refreshToken, expires}) {
            // 在这里把用户名和token保存起来
            localStorage.setItem('currentUser_name', userName)
            localStorage.setItem('currentUser_token', userToken)
            localStorage.setItem('currentUser_refresh_token', refreshToken)
            let now = new Date().getTime()
            let expiresTime = now + expires * 1000
            console.log(expires)
            localStorage.setItem('expires', expiresTime)
            localStorage.setItem('logintime', new Date().getTime())
            localStorage.setItem('isLogin', 'true')
        },
        setPermissions (state, {permissions}) {
            localStorage.setItem('permissions', permissions)
        },
        setMenuList (state, {menuList}) {
            localStorage.setItem('menuList', menuList)
        },
        clearUser () {
            sessionStorage.clear()
            localStorage.clear()
        }
    },
    actions: {
        loginTest (context, { username, password, router, route, toast, redirect }) {
            console.log(username)
            axios({
                method: 'post',
                url: 'oauth/token',
                params: {
                    'username': username,
                    // 'uuid': 'oh5bY1PEiLWcbXz_sZzkcyJRQDZI',
                    'password': password,
                    'grant_type': 'password',
                    'scope': 'all'
                },
                auth: {
                    username: 'client',
                    password: 'secret'
                }
            }).then(function (response) {
                console.log(response)
                console.log(route)
                context.commit('setUser', {
                    'userName': username,
                    'userToken': response.data.access_token,
                    'refreshToken': response.data.refresh_token,
                    'expires': response.data.expires_in
                })
                axios({
                    method: 'get',
                    url: '/v1/sys/permission/tree',
                    params: {
                    }
                }).then((response) => {
                    console.log(response)
                    context.commit('setMenuList', {
                        'menuList': JSON.stringify(response.data.content),
                    })
                    let permissionsArr = []
                    response.data.content.forEach((item) => {
                        item.list1.forEach((term)=> {
                            term.list2.forEach((em) => {
                                permissionsArr.push(em.perms)
                            })
                        })
                    })
                    console.log(permissionsArr)
                    context.commit('setPermissions', {
                        'permissions': JSON.stringify(permissionsArr),
                    })
                    if (redirect) {
                        router.push({ path: redirect})
                    } else {
                        router.push({ path: response.data.content[0].list1[0].route})
                        localStorage.setItem('defultTag', JSON.stringify(response.data.content[0].list1[0]))
                        // this.$store.tag.state.tabList = {
                        //     route: response.data.content[0].list1[0].route,
                        //     menuName: response.data.content[0].list1[0].menuName,
                        //     id: response.data.content[0].list1[0].id
                        // }
                    }
                    // router.push({ path: redirect})
                })
                axios({
                    method: 'get',
                    url: '/video/user/getLoginUser',
                    params: {
                    }
                }).then((response) => {
                    console.log(response)
                    localStorage.setItem('accountInfo', JSON.stringify(response.data.content))
                    localStorage.setItem('accountId', JSON.stringify(response.data.content.id))
                    if(response.data.content.bangdingAppId){
                        localStorage.setItem('appId', response.data.content.bangdingAppId)
                        localStorage.setItem('appName', response.data.content.bangdingAppName)
                    }
                })
                axios({
                    method: 'get',
                    url: '/video/info/getAppList',
                    params: {
                        pageNo: 1,
                        pageSize: 100
                    }
                }).then((response) => {
                    localStorage.setItem('appList', JSON.stringify(response.data.content))
                    localStorage.setItem('appObj', JSON.stringify(response.data.content[0]))
                    if(JSON.parse( localStorage.getItem("accountInfo") )?.bangdingAppId ){
                        localStorage.setItem('appId', JSON.parse( localStorage.getItem("accountInfo") ).bangdingAppId)
                        localStorage.setItem('appName', JSON.parse( localStorage.getItem("accountInfo") ).bangdingAppName)
                    }else{
                        localStorage.setItem('appId', response.data.content[0].appId)
                        localStorage.setItem('appName', response.data.content[0].name)
                    }
                    
                })
            }).catch(function (error) {
                if (error) {
                    console.log(error.stack)
                }
                toast('账户或密码错误')
            })
        },
        // loginApp (context, { userData, router }) {
        //   context.commit('setUser', { 'userName': userData.userName, 'userToken': userData.userToken })
        //   // router.push({ path: '/book' })
        //   // router.push({ path: '/course', query: { lwtId: userData.lwtId } })
        //   // console.log('登录验证app登录')
        // }
        loginOut (context) {
            context.commit('clearUser')
            // router.go(0)
            window.location.href = '/'
            // router.push({ path: '/' })
        }
    },
    modules: {}
}
